import { render, staticRenderFns } from "./VideoScriptReverse.vue?vue&type=template&id=4e408424&scoped=true"
import script from "./VideoScriptReverse.vue?vue&type=script&lang=js"
export * from "./VideoScriptReverse.vue?vue&type=script&lang=js"
import style0 from "./VideoScriptReverse.vue?vue&type=style&index=0&id=4e408424&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e408424",
  null
  
)

export default component.exports